import { Menu } from "@mui/material";
import { styled, type Theme } from "@mui/material/styles";

export const StyledMenu = styled(Menu)(({ theme }) => ({
  zIndex: theme.zIndex.tooltip
}));

export const sectionTitleSx = (theme: Theme) => ({
  background: "transparent",
  color: theme.customColors.textPrimary,
  fontSize: "0.625rem",
  fontWeight: 600,
  letterSpacing: "0.03125rem",
  lineHeight: "1rem",
  margin: 0,
  padding: theme.spacing(1, 0.5),
  textTransform: "uppercase" as const
});

export const sectionDividerSx = (theme: Theme) => ({
  borderColor: theme.customColors.border,
  margin: "0.5rem 0rem"
});
